import { Box, Button, Paper, TextField } from '@mui/material';
import React, { useContext, useEffect, useState, useRef } from 'react';
import { Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import client from '../../API/client';
import Avatar from '../../assets/Images/DefaultAvatar.jpg';
import Colors from '../../Constant/Colors';
import { UserContextData } from '../../context/AuthContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useFormik } from 'formik';
import AWS from 'aws-sdk';
import * as Yup from 'yup';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
export const DesignerEditprofile = (props) => {
  const inputRef = useRef();
  const { id } = useParams();
  const [username, setUsername] = useState('');
  const [fullname, setfullname] = useState('');
  const [bio, setBio] = useState('');
  const [skills, setSkills] = useState('');
  const [portfolio, setPortfolio] = useState('');
  const [isData, setIsData] = useState(false);
  const [avatarimg, setAvatar] = useState('');
  const { Designer } = useContext(UserContextData);

  const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/gif', 'image/png'];
  const config = {
    bucketName: process.env.REACT_APP_BUCKET,
    dirName: 'profile-pic/',
    region: process.env.REACT_APP_REGION,
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRETE_ACCESS_KEY,
  };

  const s3 = new AWS.S3({
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRETE_ACCESS_KEY,
    region: process.env.REACT_APP_REGION,
  });

  const formik = useFormik({
    initialValues: {
      avatar: '',
    },
    onSubmit: async (values) => {
      const file = values.avatar;
      console.log(file);
      const params = {
        Bucket: process.env.REACT_APP_BUCKET,
        dirName: 'profile-pic/',
        Key: file.name,
        Body: file,
      };
      if (file) {
        const response = await s3.upload(params).promise();
        const avatarlink = response.Location;
        console.log('Response', avatarlink);

        client
          .put('/designer/profile/profile-pic', {
            avatarlink,
            id,
          })
          .then((res) => {
            if (res.status === 200) {
              toast.success(res.data, {
                position: toast.POSITION.TOP_CENTER,
              });
              getData();
            }
          })
          .catch((err) => {
            console.log(err);
            toast.error(err.response.data, {
              position: toast.POSITION.TOP_CENTER,
            });
          });
      }
    },
    validationSchema: Yup.object({
      avatar: Yup.mixed()
        .test('fileSize', 'File Size is too large', (value) => value.size >= 20000)
        .test('fileType', 'Unsupported File Format', (value) => SUPPORTED_FORMATS.includes(value.type)),
    }),
  });

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const designer_id = await Designer.designer_id;
    const payload = { designer_id };
    try {
      await client
        .post(`/designer/profile`, payload, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          console.log(res.status);

          setIsData(true);
          setUsername(res.data[0].username);
          setfullname(res.data[0].fullname);
          setBio(res.data[0].bio);
          setSkills(res.data[0].skills);
          setPortfolio(res.data[0].portfolio);
          setAvatar(res.data[0].avatar);
        });
    } catch (error) {
      toast.error('Oops!! Something went wrong', {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const UpdateProfile = async () => {
    const payload = { id, username, fullname, bio, skills, portfolio };
    console.log(payload);
    try {
      await client
        .put(`/designer/profile/update_profile`, payload, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          console.log(res.data);
          if (res.status === 200) {
            toast.success('Profile Updated Succesfully !!', {
              position: toast.POSITION.TOP_CENTER,
            });
          } else {
            toast.error('OOps!! Something went wrong ', {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        });
    } catch (error) {
      console.log(error);
      toast.error('OOps!! Something went wrong ', {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const handleFileInput = (e) => {
    formik.values.avatar = e.target.files[0];
    formik.handleSubmit();
  };

  const avatarStyle = {
    backgroundImage: `url(${avatarimg})`,
    backgroundSize: 'cover',
  };

  return (
    <>
      <Box m="20px">
        <ToastContainer />
        <Paper elevation={4} style={{ padding: '20px' }}>
          <Paper elevation={4} style={{ padding: '20px' }}>
            <Row style={{ textAlign: 'center' }}>
              <h4>Edit Profile</h4>
            </Row>
            <Row style={{ alignItems: 'center', justifyContent: 'center' }}>
              {avatarimg === null ? (
                <img
                  src={Avatar}
                  style={{
                    width: 160,
                    height: 140,
                    borderRadius: '100%',
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <img
                  src={avatarimg}
                  style={{
                    width: 160,
                    height: 140,
                    borderRadius: '100%',
                    objectFit: 'cover',
                  }}
                />
              )}
              <form onSubmit={formik.handleSubmit} className="avatar user-profile" style={{ textAlign: 'center' }}>
                <Button
                  sx={{
                    textAlign: 'center',
                    borderRadius: '50%',
                  }}
                  style={{ avatarStyle }}
                  onClick={() => {
                    inputRef.current.click();
                  }}>
                  change profile pic
                  <input ref={inputRef} type="file" id="avatar" onChange={(e) => handleFileInput(e)} hidden />
                  {avatarimg === null || avatarimg === undefined ? (
                    <EditOutlinedIcon
                      sx={{
                        color: Colors.primary,
                        fontSize: '40px',
                        marginLeft: '10px',
                        // marginTop: '0px',
                        bgcolor: 'aliceblue',
                        borderRadius: '25px',
                        padding: '10px',
                      }}
                    />
                  ) : (
                    ''
                  )}
                </Button>
              </form>
            </Row>
            <TextField
              label="Username"
              name="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              variant="outlined"
              style={{
                width: '30%',
                margin: '10px',
              }}
            />
            <TextField
              label="Fullname"
              name="fullname"
              value={fullname}
              onChange={(e) => setfullname(e.target.value)}
              variant="outlined"
              style={{
                width: '30%',
                margin: '10px',
              }}
            />
            <TextField
              label="Skills"
              name="skills"
              value={skills}
              onChange={(e) => setSkills(e.target.value)}
              variant="outlined"
              style={{
                width: '30%',
                margin: '10px',
              }}
            />
            <TextField
              label="About/Description"
              name="bio"
              value={bio}
              multiline
              rows={4}
              onChange={(e) => setBio(e.target.value)}
              variant="outlined"
              style={{
                width: '93%',
                margin: '10px',
              }}
            />
            <TextField
              label="Portfolio Url"
              name="portfolio"
              value={portfolio}
              onChange={(e) => setPortfolio(e.target.value)}
              variant="outlined"
              style={{
                width: '93%',
                margin: '10px',
              }}
            />
            <Button
              variant="contained"
              onClick={() => UpdateProfile()}
              style={{
                width: '93%',
                margin: '10px',
                marginTop: '30px',
                color: Colors.primary,
                backgroundColor: Colors.secondary,
              }}>
              Update Profile
            </Button>
          </Paper>
        </Paper>
      </Box>
    </>
  );
};
